// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles-module__search-box--himFZ{width:100%}`, "",{"version":3,"sources":["webpack://./src/components/SpacesTree/Search/styles.module.css"],"names":[],"mappings":"AAAA,kCACE,UAAA","sourcesContent":[".search-box {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-box": `styles-module__search-box--himFZ`
};
export default ___CSS_LOADER_EXPORT___;
